import React, {useEffect, useState, useMemo} from "react";
import {Link} from "react-router-dom";
import Loading from "../bricks/Loading";
import ErrorMessage from "../bricks/ErrorMessage";
import useTranslation from "../hooks/useTranslation";
import {axiosInstance} from "../axios";

const Help = () => {
    const {t, language} = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState();
    const [files, setFiles] = useState([]);

    useEffect(() => {
        const init = async () => {
            try {
                const {data} = await axiosInstance.get(`/api/help`);
                setFiles(Array.isArray(data) ? data : []);
            } catch (err) {
                setError(err);
            } finally {
                setIsLoading(false);
            }
        };
        init();
    }, []);

    // normalizuj kód jazyka (např. "cs-CZ" -> "cs")
    const langKey = useMemo(() => (language || "").split("-")[0].toLowerCase(), [language]);

    const renderContent = () => {
        if (isLoading) return <Loading/>;
        if (error) return <ErrorMessage error={error}/>;

        if (!files.length) {
            return <div>{t?.("noFiles") ?? "Žádné soubory nejsou k dispozici."}</div>;
        }

        return (
            <div className="help-list">
                {files.map((doc) => {
                    const fl = doc?.filenameLocale || {};
                    // primárně podle aktuálního jazyka, sekundárně zkus přesný kód (kdyby byl jiný registr)
                    const current = fl[langKey] || fl[language] || null;

                    return (
                        <div key={doc._id} className="help-item">
                            {/*<div className="help-title">*/}
                            {/*    <strong>{doc.label || t?.("file") || "Soubor"}</strong>*/}
                            {/*</div>*/}

                            {current?.filename ? (
                                <a
                                    href={`public/help/${current.filename}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="help-link"
                                    title={current.filename}
                                >
                                    {current.locale} - {t("download")}
                                </a>
                            ) : (
                                <span className="help-missing">
                  {t?.("notAvailableInLanguage") ?? "Pro tento jazyk není k dispozici."}
                </span>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="Help">
            <Link to="/" className="Button button main backToApp">
                {"<- " + t("backToApp")}
            </Link>
            {renderContent()}
        </div>
    );
};

export default Help;
